import { GeneratedSchedugramServerClient } from "../../generated-schedugram-server-client";
import type { paths } from "../../generated/schedugram-server-openapi-types";

const client = new GeneratedSchedugramServerClient<paths>();

type CodeExchangePath = paths["/facebook/business-login/code-exchange"]["post"];

export type FacebookBusinessLoginCodeExchangeBody =
  CodeExchangePath["requestBody"]["content"]["application/json"];
export type FacebookBusinessLoginCodeExchangeResult =
  CodeExchangePath["responses"][200]["content"]["application/json"];
export type DiscoveredFacebookPage =
  FacebookBusinessLoginCodeExchangeResult["pages"][number];

/**
 * SKE-4579. Hands the authorization code to the server, which exchanges it,
 * keeps the token and answers with a connection handle plus the Pages it
 * reaches. Only reached when the login came back with a code.
 */
export async function exchangeFacebookBusinessLoginCode(
  body: FacebookBusinessLoginCodeExchangeBody
): Promise<FacebookBusinessLoginCodeExchangeResult> {
  const result = await client.client.POST(
    "/facebook/business-login/code-exchange",
    { body }
  );
  return client.unwrap(result);
}

/**
 * SKE-5310. Hands back a handle the person will not use. The server deletes
 * it, and revokes its credential only when Meta typed it a system-user token
 * and no connected account shares the grant.
 */
export async function discardFacebookBusinessLoginConnection(
  connectionHandle: string
): Promise<void> {
  const result = await client.client.POST("/facebook/business-login/discard", {
    body: { connectionHandle },
  });
  await client.ensureOk(result);
}
